<app-viz-thumbnail-container [size]='size' *ngIf="data" class='vizTextZoneThumbnail' [title]='title'>
    <div class="vizTextZone">
        <div class="vizTextZoneContent">
            <div *ngFor="let textArray of data[0].values" id="id">
                <div *ngFor="let text of textArray" class='genomic' [class.emphasize]="text === textArray[0]"
                    [innerHTML]="setTextLayoutAutoBr(text)"></div>
            </div>
        </div>
    </div>
</app-viz-thumbnail-container>